// extracted by mini-css-extract-plugin
export default {"content":"MeterReading_content__iLC+H","tabs":"MeterReading_tabs__g+abn","scadaList":"MeterReading_scadaList__w2-Q7","toolbar":"MeterReading_toolbar__+9RhS"};